import React from 'react';
import { useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { useNavigate, useSearchParams } from "react-router-dom";



const Home = () => {
    const { keycloak, initialized } = useKeycloak();
    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {

        console.log("K:", keycloak.authenticated);


        let cfgParam = searchParams.get('cfg');
        let cfgOverride = searchParams.get('override');



        if (process.env.REACT_APP_TENANT && cfgOverride != 'true') {
            cfgParam = {
                "background": "url(" + process.env.REACT_APP_BACKGROUND + ")",
                "language": process.env.REACT_APP_LANGUAGE,
                "tenant": process.env.REACT_APP_TENANT,
                "inputbox": process.env.REACT_APP_INPUTBOX,
                "notifier": process.env.REACT_APP_NOTIFIER,
            }
        }







        if (!!keycloak.authenticated) {



            let user = {
                email: keycloak.tokenParsed.email,
                name: keycloak.tokenParsed.given_name,
                surname: keycloak.tokenParsed.family_name,
                preferred_username: keycloak.tokenParsed.preferred_username,
                full_name: keycloak.tokenParsed.name
            }
            localStorage.setItem("user", JSON.stringify(user));
            if (cfgParam == null) {
                navigate("/config");
            } else {
                navigate("/avatar");
            }
        } else {
            const items = JSON.parse(localStorage.getItem('user'));

            if (items != null) {
                if (cfgParam == null) {
                    navigate("/config");
                } else {
                    navigate("/avatar");
                }
            }

        }




    }, [keycloak.authenticated]);

    useEffect(() => {

        let cfgParam = searchParams.get('cfg');
        let cfgOverride = searchParams.get('override');

        if (process.env.REACT_APP_TENANT && cfgOverride != 'true') {

            cfgParam = {
                background: "url(" + process.env.REACT_APP_BACKGROUND + ")",
                language: process.env.REACT_APP_LANGUAGE,
                tenant: process.env.REACT_APP_TENANT,
                inputbox: process.env.REACT_APP_INPUTBOX,
                notifier: process.env.REACT_APP_NOTIFIER,
            }

            localStorage.setItem('config', JSON.stringify(cfgParam));
        } else {

            if (cfgParam != null) {
                localStorage.setItem('config', window.atob(cfgParam));
            }


        }



    }, []);








    return (
        <div>

            <Card className="center-card" style={{ width: '28rem' }}>
                <Card.Img style={{ padding: '15px' }} variant="top" src="https://www.interlogica.it/wp-content/uploads/2021/10/logo_interlogica_1.svg" />
                <Card.Body>
                    <Card.Title>MetaHuman</Card.Title>

                    {!keycloak.authenticated && (
                        <Card.Text>
                            Sviluppato utilizzando le tecnologie più recenti di elaborazione del linguaggio naturale, il nostro assistente virtuale è in grado di comprendere e interpretare le domande degli utenti, fornendo risposte pertinenti e utili in tempo reale.
                        </Card.Text>
                    )}
                    {!keycloak.authenticated && (
                        <div class="col text-center">
                            <Button variant="primary" onClick={() => keycloak.login()} >Login</Button>
                        </div>

                    )}


                    {!!keycloak.authenticated && (

                        <div class="col text-center">
                            <Button variant="success" onClick={() => navigate("/config")} >Configuration</Button>
                            &nbsp;&nbsp;
                            <Button className="btn btn-danger" onClick={() => keycloak.logout()} >Logout</Button>
                        </div>


                        /*({keycloak.tokenParsed.preferred_username})*/

                    )}


                </Card.Body>
            </Card>






        </div>
    );
};

export default Home;